import tw, { styled } from "twin.macro";

const FuncButtonStyled = styled.button(({ isActive }) => [
	tw`h-[40px] leading-[1.5] font-roboto shadow-input bg-white text-secondary-700 text-sm font-semibold px-4 py-2 border border-[#D0D5DD] flex gap-2 items-center rounded-[4px] self-center
    hover:bg-gray-50 focus:ring-2 focus:ring-ring-blue-primary shadow-none
  `,
	isActive &&
		tw`ring-2 !ring-ring-blue-primary border-utility-brand-300 !text-royal-blue`,
]);

export default FuncButtonStyled;
